import { z } from "zod";

export const COVERAGE_GAP_TABS = [
  { value: "claims", label: "Claims" },
  { value: "requesters", label: "People to tell" },
] as const;

/** What a coverage gap's page shows. It lives in the URL, so a link opens the same view. */
export const coverageGapDetailFiltersSchema = z.object({
  tab: z.enum(["claims", "requesters"]).default("claims"),
});

export type CoverageGapDetailFilters = z.output<typeof coverageGapDetailFiltersSchema>;
